<template>
  <div class="mask-layer mask role">
    <div class="container">
      <div class="title">
        选择角色身份
      </div>
      <div class="content">
        <el-transfer v-model="value" :data="data" :titles="['待选择片区', '已选择片区']"></el-transfer>
      </div>
      <div class="btn-wrap">
        <button type="button" class="btn mr20" @click="save">确认</button>
        <button type="button" class="btn" @click="close">关闭</button>
      </div>
      <div class="close" @click="close">X</div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "insurance",
    // props:['sendData'],
    props:['organizationId','roleIds'],
    data() {

      return {
        model: {
          value1: '',
          id: null,//id
          roleName: null,//角色名称
          projectId: null,//所属系统id
          ruleCode: null,//角色编码
          status: null,//是否启用
          remark: null,//备注

        },
        radio: '1',
        projectList: [],
        data: [],
        value: [],
        selectRoles:null,
        roleValue:null,
        hideSend: false,
      }
    },
    mounted() {
      // this.model.roleId=this.data.rescuerType;
      // this.$state.dispatch('fetchCityList');
      // this.getCity();
      // if(this.sendData.id){
      //   console.log(this.sendData)
      //   // this.model.status=this.sendData.status
      //   for(let key in this.model){
      //     this.model[key]=this.sendData[key]
      //   }
      // }
      this.getroleList()
      // this.selectList()
    },

    computed: {},
    methods: {
      getroleList() {
        this.$axios.get('/admin/district/simpList/' + this.organizationId).then(res => {//角色身份列表
          let data = res.data.data
          this.selectRoles = data
          console.log(this.selectRoles,'selectRoles')
          if (data) {
            data.forEach(item => {
              item.label = item.districtName
              item.key = item.id
            })
            this.data = data
            if(this.roleIds) {
              let arr = []
              this.roleIds.split(',').forEach(item => {
                arr.push(Number(item))
              })
              this.value = arr
            }
          }
        })

        // this.$axios.get('/admin/district/simpList/'+ this.model.organizationId).then(res => {
        //
        // });
      },
      selectList(){
        console.log(this.roleIds,'this.roleIds')
        console.log(this.selectRoles,'this.selectRoles')
          if(this.roleIds){
            this.selectRoles.forEach(item => {
              this.roleIds.forEach(item2=>{
                console.log(item2,'item2')
                if(item.id == item2){
                  this.data.push(item.districtName)
                }
              })
            })
          }

      },
      fetchData(args) {
      },
      cellStyle({row, column, rowIndex, columnIndex}) {
        return 'height:20px;font-size:12px';
      },
      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return 'background-color: #f4f5f7;height:40px;color:#4a4a4a!important;font-size:13px'
        }
      },
      handleSelectionChange(val) {
        // this.multipleSelection = val;
        val.forEach(item => {
          if (item.range) {
            item.range = parseFloat(item.range)
          }
        })
        console.log(val)
        this.model.rule.accidentRanges = val;
      },
      close() {
        this.$emit('func', this.hideSend);
      },
      save() {
        // var msg='保存成功'
        let datas =[]
        if (this.value.length>0){
          this.value.forEach(id=>{
            this.data.forEach(item=>{
              if (item.id==id){
                datas.push(item)
              }
            })
          })
        }
        this.$emit('getDatas',datas)
        this.close()
        // this.$axios.post('/rm-user-manage/api/admin/role/set', this.model).then(res => {
        //   let data = this.AppUtils.checkResponse(res);
        //   if (data) {
        //     console.log(data)
        //     // if (data.code == 0) {
        //     //   this.$message.success(msg);
        //     //   this.$emit('hideEditMask');
        //     //   this.$emit('fetchData');
        //     //   this.$emit('func', this.hideSend);
        //     //
        //     // }
        //   }
        // });
      },

    }
  }
</script>

<style scoped lang="scss">
  /*@import '../../assets/css/cover.css';*/
  .systemUl {
    display: flex;

    .systemLi {
      width: 100px;
      line-height: 30px;
      text-align: center;

    }
  }

  .reset {
    position: relative;
    left: -30px;
  }

  .mask-layer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .form_item {
    display: flex;
    justify-content: center;
    /*margin-bottom: 15px;*/
  }

  .form_left {
    line-height: 32px;
    margin-right: 10px;
  }

  .form_right {
    line-height: 32px;
    width: 200px !important;
    box-sizing: border-box;
    padding-left: 10px;
    text-align: left;
    height: 45px;
  }

  .container {
    background-color: #fff;
    width: 800px;
    box-sizing: border-box;
    padding-bottom: 10px;
    max-height: 650px;
    position: relative;
    overflow-y: scroll;

    .close {
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      position: absolute;
      top: 10px;
      right: 5px;
      cursor: pointer;
    }

    .title {
      height: 41px;
      line-height: 41px;
      box-sizing: border-box;
      padding-left: 16px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #4A4A4A;
      text-align: left;
      border-bottom: 1px solid #ECF1F4;
    }

    .content {
      padding: 16px;
      box-sizing: border-box;

      .topInfo {
        display: flex;
        justify-content: left;
        margin-bottom: 27px;

        span {
          line-height: 21px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
        }
      }

      .sendInfo {
        display: flex;
        justify-content: left;
        margin-bottom: 10px;

        span {
          line-height: 21px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
        }
      }

      .infoZone {
        width: 568px;
        height: 250px;
        border: 1px solid #D7D7D7;
        border-radius: 2px;
        position: absolute;
        text-align: left;
        box-sizing: border-box;
        padding: 11px 20px;

        p {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4A4A4A;

          a {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #FF4C00;
          }
        }

        .p1 {
          margin-bottom: 25px;
        }

        .p2 {
          margin-bottom: 11px;
        }

        .p3 {
          margin-bottom: 7.5px;
        }

        textarea {
          position: absolute;
          left: 0;
          top: 0px;
          width: 100%;
          height: 100%;
          resize: none;
          box-sizing: border-box;
          /*padding: 0px 22px;*/
        }

        button {
          position: absolute;
          right: 14px;
          bottom: 9.5px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #FFFFFF;
          background: #1038B7;
          border-radius: 2px;
          padding: 2px 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// role.vue?30830d8e